import gql from 'graphql-tag';

export const cardCategoryDetails = gql`
  fragment cardCategoryDetails on CardCategory {
    id
    name
    is_active
    asset_image {
      id
      url
    }
    preview_asset_image {
      id
      url
    }
    description
    background_color
    foreground_color
    push_notification_type
  }
`;
